import script from "./SubscriptionConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionConfirm.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionConfirm.vue?vue&type=style&index=0&id=d5514d48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5514d48"]])

export default __exports__